/**
 * v-visible-state
 *
 * <span v-visible-state="'key'"></span>
 */
export default {
  bind(el, binding, vnode) {
    const vm = vnode.context
    const key = `${vm.$options.name}:${binding.value}`
    const type = binding.modifiers

    function setState(state) {
      if (type.visibility) {
        el.style.visibility = state
      } else if (type.opacity) {
        el.style.opacity = state
      } else {
        // default as display
        el.style.display = state
      }
    }

    let state = vm.$storage.getState(key)
    setState(state)
    // handle visible change event
    const observer = new window.MutationObserver(mutations => {
      const style = window.getComputedStyle(el)
      if (type.visibility) {
        state = el.style.visibility
      } else if (type.opacity) {
        state = type.opacity
      } else {
        state = style.display
      }
      vm.$storage.setState(key, state)
    })

    observer.observe(el, { attributes: true })
  }
}
